import { memo } from 'react';
import { useAnimation } from '@/context/AnimationContext';
import { useI18n } from '@/context/I18nContext';
import { TopBar } from '@/components/editor/TopBar';
import { ToolPanel } from '@/components/editor/ToolPanel';
import { AnimationCanvas } from '@/components/editor/AnimationCanvas';
import { PropertyPanel } from '@/components/editor/PropertyPanel';
import { Timeline } from '@/components/editor/Timeline';

const MemoTimeline = memo(Timeline);
const MemoPropertyPanel = memo(PropertyPanel);
const MemoToolPanel = memo(ToolPanel);

export function EditorLayout() {
  const { state } = useAnimation();
  const { t } = useI18n();

  return (
    <div
      data-testid="editor-layout"
      className="grid h-screen w-screen overflow-hidden text-foreground grain-overlay"
      style={{
        gridTemplateColumns: '52px 1fr 260px',
        gridTemplateRows: '44px 1fr 220px',
        background: 'linear-gradient(180deg, hsl(220, 16%, 9%) 0%, hsl(220, 14%, 11%) 100%)',
      }}
    >
      {/* Top Bar */}
      <div className="col-span-3 border-b border-white/[0.06] panel-glass z-10">
        <TopBar />
      </div>

      {/* Left Tool Panel */}
      <div className="row-span-1 border-r border-white/[0.06] panel-glass">
        <MemoToolPanel />
      </div>

      {/* Center Canvas */}
      <div
        className="relative overflow-hidden flex items-center justify-center"
        data-testid="canvas-area"
        style={{ background: 'radial-gradient(ellipse at center, hsl(220, 16%, 13%) 0%, hsl(220, 16%, 8%) 100%)' }}
      >
        <AnimationCanvas />
      </div>

      {/* Right Property Panel */}
      <div className="row-span-1 border-l border-white/[0.06] panel-glass overflow-y-auto">
        <MemoPropertyPanel />
      </div>

      {/* Bottom Timeline */}
      <div className="col-span-2 border-t border-white/[0.06] panel-glass overflow-hidden">
        <MemoTimeline />
      </div>

      {/* Bottom right info */}
      <div className="border-t border-l border-white/[0.06] panel-glass p-3 overflow-y-auto">
        <div className="font-mono text-[10px] text-muted-foreground space-y-1.5">
          <div className="flex justify-between"><span className="opacity-50">{t('fps')}</span> <span>{state.project.fps}</span></div>
          <div className="flex justify-between"><span className="opacity-50">{t('frame')}</span> <span>{state.currentFrame}/{state.project.totalFrames}</span></div>
          <div className="flex justify-between"><span className="opacity-50">{t('time')}</span> <span>{(state.currentFrame / state.project.fps).toFixed(2)}s</span></div>
          <div className="flex justify-between"><span className="opacity-50">{t('layers')}</span> <span>{state.project.layers.length}</span></div>
          <div className="flex justify-between"><span className="opacity-50">{t('zoom')}</span> <span>{Math.round(state.zoom * 100)}%</span></div>
        </div>
      </div>
    </div>
  );
}
